module.exports = __webpack_public_path__ + "static/media/YourHotels.d463d749.png";